// extracted by mini-css-extract-plugin
export default {"popup":"antd_popup__h+PGq"};